// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: 'c016a7e1b84a6d5a2ac9963fda78db368e4d68fd',
  short: 'c016a7e',
  builtAt: '2026-10-26T15:38:16.616Z',
} as const;
